import { withLocalState } from 'pyradux';

import MyAccountContainer from './MyAccount.container';
import reducer from './MyAccount.reducer';
import MyAccountSagas from './MyAccount.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'myAccount',
  sagas: [MyAccountSagas],
};

export default withLocalState(withLocalStateOptions, MyAccountContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/index.js